module.exports = __webpack_public_path__ + "static/img/th-crads-technical2-01.9fd7b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crads-technical2-01.png
// module id = YyEH
// module chunks = 1